import { useState, useEffect, useCallback } from "react";
import axios from "axios";

const useRequest = (
  url,
  method = "GET",
  payload = null,
  queryParams = {},
  autoFetch = true
) => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(autoFetch);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(false);
  const [requestParams, setRequestParams] = useState(queryParams);

  const fetchData = useCallback(
    async (newParams = {}) => {
      setLoading(true);
      setError(null);
      setSuccess(false);

      try {
        const response = await axios({
          url: `${process.env.REACT_APP_URL}${url}`,
          method,
          data: payload,
          params: { ...requestParams, ...newParams }, // Merge new params
          headers: {
            "Content-Type": "application/json",
          },
        });

        setData(response.data);
        setSuccess(true);
      } catch (err) {
        setError(err.response?.data?.message || err.message);
        setSuccess(false);
      } finally {
        setLoading(false);
      }
    },
    [url, method, payload, requestParams]
  );

  useEffect(() => {
    if (autoFetch) {
      fetchData();
    }
  }, [fetchData, autoFetch]);

  return {
    data,
    setData,
    loading,
    error,
    setError,
    success,
    refetch: (newParams = {}) => {
      setRequestParams((prev) => ({ ...prev, ...newParams })); // Update params
      fetchData(newParams); // Fetch with new params
    },
  };
};

export default useRequest;
